import { FrontendEnvSchema } from '@envSchema';

// Filter out all keys that are not prefixed with VITE_

const filteredEnv = Object.fromEntries(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Object.entries((import.meta as any).env).filter(([key]) =>
    key.startsWith('VITE_'),
  ),
);

export const FRONTEND_ENV = FrontendEnvSchema.parse(filteredEnv);

console.log('FRONTEND_ENV', FRONTEND_ENV);
